import React from 'react';

import AdaptiveImage from '@/components/Elements/AdaptiveImage/AdaptiveImage';

import { PortfolioParagraphContentProps } from '@/helpers/getParagraphForDynamicPage';

import { IImage, IMediaFormat } from '@/types/types';

import './VideoLoopedParagraph.scss';

interface VideoLoopedProps extends PortfolioParagraphContentProps {
  videoLooped: IMediaFormat;
  sourceImage?: IImage;
  title: string;
}

export const VideoLoopedParagraph = ({ videoLooped, title, sourceImage }: VideoLoopedProps) => {
  const videoUrl = process.env.IMAGE_STORAGE_PATH + videoLooped.hash + videoLooped.ext;

  return (
    <div className="VideoLoopedParagraph_wrapper">
      <video src={videoUrl} autoPlay muted loop playsInline />
      {sourceImage && <AdaptiveImage image={sourceImage} alt={title} className="VideoLoopedParagraph_source" />}
      {title && <p className="subtitle-3">{title}</p>}
    </div>
  );
};
